var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIconGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "globe",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 15.525,
    viewBox: "0 0 14.525 14.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M7.263,14.525H7.242a7.262,7.262,0,0,1-5.115-12.4A7.214,7.214,0,0,1,7.247,0h.031A7.262,7.262,0,0,1,12.4,12.4a7.213,7.213,0,0,1-5.115,2.127Zm1.5-1.513a5.948,5.948,0,0,0,4.4-5.09H10.531A10.747,10.747,0,0,1,8.766,13.012Zm-3.005,0A10.777,10.777,0,0,1,4,7.923H1.357A5.946,5.946,0,0,0,5.76,13.012Zm1.5-.171A9.488,9.488,0,0,0,9.207,7.923H5.321A9.511,9.511,0,0,0,7.263,12.841ZM13.168,6.6a5.946,5.946,0,0,0-4.4-5.09A10.782,10.782,0,0,1,10.529,6.6Zm-3.963,0A9.513,9.513,0,0,0,7.263,1.684,9.491,9.491,0,0,0,5.319,6.6Zm-5.21,0A10.739,10.739,0,0,1,5.76,1.513a5.946,5.946,0,0,0-4.4,5.09Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M7.263,14.525H7.242a7.262,7.262,0,0,1-5.115-12.4A7.214,7.214,0,0,1,7.247,0h.031A7.262,7.262,0,0,1,12.4,12.4a7.213,7.213,0,0,1-5.115,2.127Zm1.5-1.513a5.948,5.948,0,0,0,4.4-5.09H10.531A10.747,10.747,0,0,1,8.766,13.012Zm-3.005,0A10.777,10.777,0,0,1,4,7.923H1.357A5.946,5.946,0,0,0,5.76,13.012Zm1.5-.171A9.488,9.488,0,0,0,9.207,7.923H5.321A9.511,9.511,0,0,0,7.263,12.841ZM13.168,6.6a5.946,5.946,0,0,0-4.4-5.09A10.782,10.782,0,0,1,10.529,6.6Zm-3.963,0A9.513,9.513,0,0,0,7.263,1.684,9.491,9.491,0,0,0,5.319,6.6Zm-5.21,0A10.739,10.739,0,0,1,5.76,1.513a5.946,5.946,0,0,0-4.4,5.09Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIconGlobal);
export default __webpack_public_path__ + "static/media/language-icon-global.2d30487466a06e60530f8930d994f89c.svg";
export { ForwardRef as ReactComponent };